import { ReactNode } from 'react';
import Skeleton, { SkeletonProps } from 'react-loading-skeleton';

interface SkeletonWrapperProps extends SkeletonProps {
  children: ReactNode;
  isPending: boolean;
}

export default function SkeletonWrapper({ isPending, children, ...props }: SkeletonWrapperProps) {
  return isPending ? <Skeleton {...props} /> : children;
}
